import { render, staticRenderFns } from "./api-management.vue?vue&type=template&id=0d94a126&"
import script from "./api-management.vue?vue&type=script&lang=js&"
export * from "./api-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports